import { useEffect } from "react";
import { useState } from "react";
import { supabase } from "../../../../lib/supabase/supabaseClient";
import { useCentralStore } from "../../store/Central";
import { Logger } from "../../../../lib/logger/Logger";
import { PatientEntityType } from "../../../../lib/supabase/supabaseTypes";
import { PatientItemComponent } from "./patient-item.component";
import { Button, Input } from "@mui/material";
import { Search } from "lucide-react";
import { Loading } from "../../../../components/src/animations/loading";
import { PatientSearchResult } from "@/dentlab/src/store/Search/types";
import { useSearchStore } from "../../store/Search";

export const PatientsPage = () => {
	return (
		<div className="w-full h-full">
			<div className="font-bold text-xl mb-4">Patienten</div>
			<PatientsComponent />
		</div>
	);
};

export const PatientsComponent = () => {
	const [allPatients, setAllPatients] = useState<PatientEntityType[] | PatientSearchResult[]>([]);
	const { fetchSearchResultsPatients } = useSearchStore.getState();
	const [patients, setPatients] = useState<PatientEntityType[] | PatientSearchResult[]>([]);
	const { profile } = useCentralStore.getState();
	const [loading, setLoading] = useState<boolean>(false);
	const pageSize = 20;
	const [range, setRange] = useState(pageSize);

	const searchPatients = async (query: string) => {
		setLoading(true);
		const patients = await fetchSearchResultsPatients(query);
		if (query.length == 0) {
			setPatients(allPatients);
			setLoading(false);
			return;
		}
		setPatients(patients);
		setLoading(false);
	};

	const getPatients = async () => {
		setLoading(true);
		const { data, error } = await supabase
			.from("patients")
			.select()
			.eq("organization_id", profile?.organization_id as string)
			.order("modified_at", { ascending: false })
			.range(0, range - 1);

		if (error) {
			Logger.error(error, {}, "Error fetching patients");
			return;
		}
		setAllPatients(data);
		setPatients(data);
		setLoading(false);
	};

	useEffect(() => {
		getPatients();
	}, [range]);

	return (
		<div className="h-full flex flex-col overflow-hidden pb-10">
			<div className="flex-none">
				<div className="flex items-center">
					<Input
						placeholder="Suche"
						endAdornment={<Search size={20} className="mr-2" />}
						onChange={(e) => {
							searchPatients(e.target.value);
						}}
						fullWidth
					/>
				</div>
			</div>
			<div className="flex-1 overflow-y-auto mt-4">
				<div className="flex flex-col gap-4 pb-2	">
					{loading && patients && patients.length == 0 ? (
						<div className="mt-8">
							<Loading />
						</div>
					) : (
						<>
							{patients?.map((patient) => (
								<PatientItemComponent
									key={patient.id}
									patient={patient}
								/>
							))}
							{!loading && patients.length === range && (
								<Button
									onClick={() => {
										setRange((prev) => prev + pageSize);
									}}
								>
									Mehr anzeigen
								</Button>
							)}
						</>
					)}
				</div>
			</div>
		</div>
	);
};
